// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/crypto/tct/v1/tct.proto (package penumbra.crypto.tct.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message penumbra.crypto.tct.v1.StateCommitment
 */
export const StateCommitment = proto3.makeMessageType(
  "penumbra.crypto.tct.v1.StateCommitment",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.crypto.tct.v1.MerkleRoot
 */
export const MerkleRoot = proto3.makeMessageType(
  "penumbra.crypto.tct.v1.MerkleRoot",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * An authentication path from a state commitment to the root of the state commitment tree.
 *
 * @generated from message penumbra.crypto.tct.v1.StateCommitmentProof
 */
export const StateCommitmentProof = proto3.makeMessageType(
  "penumbra.crypto.tct.v1.StateCommitmentProof",
  () => [
    { no: 1, name: "note_commitment", kind: "message", T: StateCommitment },
    { no: 2, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "auth_path", kind: "message", T: MerklePathChunk, repeated: true },
  ],
);

/**
 * A set of 3 sibling hashes in the auth path for some note commitment.
 *
 * @generated from message penumbra.crypto.tct.v1.MerklePathChunk
 */
export const MerklePathChunk = proto3.makeMessageType(
  "penumbra.crypto.tct.v1.MerklePathChunk",
  () => [
    { no: 1, name: "sibling_1", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "sibling_2", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "sibling_3", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

